import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const PricesContext = createContext(true);
/** False when the tenant turned public prices off (`SiteContent.showPrices === false`). */
export function usePricesVisible() {
    return useContext(PricesContext);
}
/** Wrap the public site once; every price-bearing view below renders no price text when `visible` is false. */
export function PricesVisibleProvider({ visible, children }) {
    return _jsx(PricesContext.Provider, { value: visible, children: children });
}
//# sourceMappingURL=PricesContext.js.map